// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
    production: false,
    apiHost: 'https://kering.test.cp-bc.com/api/v1.0',
    wsUrl: 'http://kering.test.cp-bc.com',
    title: 'Surge: kering',
    organization: 'kering',
    type: 'eyedes', // legacy
    types: ['eyedes', 'cmpman', 'galvman', 'catalog'], // For multirole support
    authType: 'azure',
    adAuthority: 'https://login.microsoftonline.com/8ac872fd-51e5-43bc-87ac-f9748cdfc118',
    adClientId: 'ea2e68d4-adfd-48fd-9de7-7b681770a5ee',
    faro: {
        url: 'https://collector-host:12345/collect',
        apiKey: 'secret',
        app: {
            name: 'frontend',
            version: '1.0.0'
        }
    }
}